export default __webpack_public_path__ + "static/1811-6873d731e22ee3282c864ade712c404e.gif";